import {customThemeConstants} from '@hconnect/uikit/src/lib2'
import {Box, Stack, Typography} from '@mui/material'

import {type Step} from '../types'

type Props = {
  title: string
  activeStep: number
  steps: Step[]
  onStepClick: (stepNumber: number) => void
}

export const SideMenuStepper = ({steps, activeStep, title, onStepClick}: Props) => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 1
      }}
    >
      <Box sx={{px: 2, py: 2}}>
        <Typography
          variant="h4"
          sx={{
            color: 'text.primary'
          }}
        >
          {title}
        </Typography>
      </Box>
      <Stack>
        {steps.map(({key, label}, index) => {
          const stepNumber = index + 1
          const isActive = activeStep === stepNumber
          const isLast = index === steps.length - 1

          return (
            <Box
              key={key}
              onClick={() => onStepClick(stepNumber)}
              sx={{
                height: '56px',
                px: 2,
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                ...(isActive && {
                  backgroundColor: customThemeConstants().palette.containerBackgroundSelected
                }),
                ...(!isLast && {
                  borderBottom: '1px solid',
                  borderColor: 'divider'
                }),
                mb: isLast ? 1 : 0,
                '&:hover': {
                  backgroundColor: isActive
                    ? customThemeConstants().palette.containerBackgroundSelected
                    : customThemeConstants().palette.containerBackgroundHover
                }
              }}
            >
              <Typography
                sx={{
                  color: 'text.primary'
                }}
              >
                {label}
              </Typography>
            </Box>
          )
        })}
      </Stack>
    </Box>
  )
}
